var map = {
	"./mb-bank.svg": "RNfv",
	"./mb-charge.svg": "o7jE",
	"./mb-pay.svg": "gcHE",
	"./mb-seven.svg": "tWC+",
	"./sv-borrow.svg": "tfS7",
	"./sv-entry.svg": "HW23",
	"./sv-recipe.svg": "4QqM",
	"./sv-return.svg": "0h8V"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LQby";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header ^\.\/.*$
// module id = LQby
// module chunks = 0